import { Box, Paper, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import {
	PickersDay,
	type PickersDayProps,
} from "@mui/x-date-pickers/PickersDay";
import type { Moment } from "moment-timezone";

type Props = {
	weekEndingDate: Moment;
	onChange: (value: Moment | null) => void;
};

const WeekDay = (
	props: PickersDayProps<Moment> & { selectedWeekEnd: Moment },
) => {
	const { day, selectedWeekEnd, ...other } = props;

	// Week runs Sunday to Saturday
	const weekStart = selectedWeekEnd.clone().subtract(6, "days").startOf("day");
	const weekEnd = selectedWeekEnd.clone().endOf("day");
	const isInWeek = day.isBetween(weekStart, weekEnd, "day", "[]");

	return (
		<PickersDay
			{...other}
			day={day}
			sx={{
				...(isInWeek && {
					backgroundColor: "primary.light",
					color: "primary.contrastText",
					borderRadius: 0,
					"&:hover": { backgroundColor: "primary.main" },
					"&.Mui-selected": {
						backgroundColor: "primary.main",
						color: "primary.contrastText",
					},
				}),
			}}
		/>
	);
};

export const WeekPickerHeader = ({ weekEndingDate, onChange }: Props) => {
	return (
		<Box sx={{ display: "flex", flexDirection: "column" }}>
			<Typography
				variant="h5"
				sx={{ fontWeight: 600, mb: 1.5, userSelect: "none" }}
			>
				Incentive Dashboard
			</Typography>

			<Paper
				elevation={2}
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 2,
					px: 1.5,
					py: 0.75,
				}}
			>
				<DatePicker
					label="Week ending"
					format="MM/DD/YYYY"
					value={weekEndingDate}
					onChange={onChange}
					slots={{
						day: (dayProps) => (
							<WeekDay {...dayProps} selectedWeekEnd={weekEndingDate} />
						),
					}}
					slotProps={{
						textField: { size: "small", sx: { width: 180 } },
					}}
				/>
			</Paper>
		</Box>
	);
};
